import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const GET_RC518_CONTROLLING_PERSONS_FORMS_REQUEST = 'GET_RC518_CONTROLLING_PERSONS_FORMS_REQUEST';
export const GET_RC518_CONTROLLING_PERSONS_FORMS_SUCCESS = 'GET_RC518_CONTROLLING_PERSONS_FORMS_SUCCESS';
export const GET_RC518_CONTROLLING_PERSONS_FORMS_FAILURE = 'GET_RC518_CONTROLLING_PERSONS_FORMS_FAILURE';

function getRc518ControllingPersonsFormsRequest() {
  return {
    type: GET_RC518_CONTROLLING_PERSONS_FORMS_REQUEST
  };
}

function getRc518ControllingPersonsFormsRecieved(rc518CpForms) {
  return {
    type: GET_RC518_CONTROLLING_PERSONS_FORMS_SUCCESS,
    rc518CpForms
  };
}

function getRc518ControllingPersonsFormsFailed() {
  return {
    type: GET_RC518_CONTROLLING_PERSONS_FORMS_FAILURE,
  };
}

export function getRc518CpForms(accountRc518FormIds, accountId) {
  return (dispatch) => {
    dispatch(getRc518ControllingPersonsFormsRequest());
    const promise = () => ApiService
      .getRc518ControllingPersonForms(accountRc518FormIds, accountId)
      .then(response => dispatch(getRc518ControllingPersonsFormsRecieved(response.data)))
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, getRc518ControllingPersonsFormsFailed, true));
        }
      });
    return promise();
  };
}
